module.exports = __webpack_public_path__ + "static/thumbnail-868c87300cd5e8d0ab5dcedb68711f19.jpg";